import { render, staticRenderFns } from "./MyAddressNew.vue?vue&type=template&id=0c668e25&"
import script from "./MyAddressNew.vue?vue&type=script&lang=js&"
export * from "./MyAddressNew.vue?vue&type=script&lang=js&"
import style0 from "./MyAddressNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports